// Pure-constants module for the region header nav enums. See
// @/components/common/HeaderNav/types for the rationale (server-side
// modules need enum members without tripping the React Client Manifest).

export enum CurrentTab {
  SNOW = 'snow_reports',
  TRIP_PLANNING = 'trip_planning',
}

export enum CurrentLink {
  SNOW_REPORT = 'snow_reports',
  WEATHER = 'weather',
  CAMS = 'cams',
  FHR = 'first_hand',
  OVERVIEW = 'overview',
  OPEN_RESORTS = 'open_resorts',
  PROJECTED_CLOSING = 'projected_closing',
  PROJECTED_OPENINGS = 'projected_openings',
  REVIEWS = 'reviews',
  TRAILMAP = 'trailmap',
  SNOWPLANNER = 'snowplanner',
  LIFTACCESS = 'liftaccess',
  LIFT_TICKETS = 'lift_tickets',
}
